import { useBreadcrumbs } from "#routers/breadcrumbsHelper";
import { FormSchemasTablePanel } from "#src/batteries-included-components/Panels/TablePanels/FormSchemasTablePanel";
import { useStorageKey } from "#src/hooks/useStorageKey";
import {
  type BreadcrumbProps,
  generateDocumentTitle,
  Page,
} from "@validereinc/common-components";
import { ResourceDefinitions } from "@validereinc/domain";
import React from "react";
import { Titled } from "react-titled";

const FormSchemaListPage = ({ breadcrumbs }: FormSchemaListPageProps) => {
  const [filterConfigStorageKey, tableConfigStorageKey, tableStateStorageKey] =
    useStorageKey(
      ["filter-configuration", "table-configuration", "table-state"],
      "forms-templates"
    );
  const crumbs = useBreadcrumbs(breadcrumbs);

  return (
    <Titled
      title={generateDocumentTitle(
        ResourceDefinitions.form_schema.label.plural,
        breadcrumbs?.at(-2)?.title
      )}
    >
      <Page
        title="Templates"
        breadcrumbs={crumbs}
      >
        <FormSchemasTablePanel
          filterConfigStorageKey={filterConfigStorageKey}
          tableConfigStorageKey={tableConfigStorageKey}
          tableStateStorageKey={tableStateStorageKey}
        />
      </Page>
    </Titled>
  );
};

type FormSchemaListPageProps = {
  breadcrumbs: BreadcrumbProps[];
};

export default FormSchemaListPage;
